module.exports = __webpack_public_path__ + "img/candidates_active.d919879a.svg";